<div class="scores-backdrop" (click)="onBackdropClick($event)">
  <div class="scores-popup">
    <div class="scores-header">
      <h3>🏆 {{ gameTitle }}</h3>
      <button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="scores-tabs">
      <button [class.active]="activeTab === 'top'" (click)="activeTab = 'top'">Top 10</button>
      <button [class.active]="activeTab === 'me'" (click)="activeTab = 'me'">Mes scores</button>
    </div>

    <div class="scores-content">
      <div *ngIf="loading" class="scores-loading">
        <mat-spinner diameter="32"></mat-spinner>
      </div>

      <div *ngIf="!loading" class="scores-list">
        <div class="score-row"
             *ngFor="let entry of (activeTab === 'top' ? topScores : myScores); let i = index">
          <span class="rank" [class.gold]="i === 0" [class.silver]="i === 1" [class.bronze]="i === 2">
            {{ i + 1 }}
          </span>
          <span class="username">{{ entry.username }}</span>
          <span class="score">{{ entry.score | number }}</span>
        </div>

        <div class="scores-empty"
             *ngIf="(activeTab === 'top' ? topScores : myScores).length === 0">
          Aucun score enregistré
        </div>
      </div>
    </div>
  </div>
</div>
